"use client";

import { Card } from "react-bootstrap";

// Helper: convert HH:MM:SS to seconds
const timeToSeconds = (timeString) => {
  if (!timeString) return 0;
  const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

// Helper: convert seconds to "HHh MMm"
const secondsToHMS = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

// Calculate productive seconds: worked - break - idle
const getProductiveSeconds = (workedTime, breakTime, idleTime) => {
  const worked = timeToSeconds(workedTime);
  const brk = timeToSeconds(breakTime);
  const idle = timeToSeconds(idleTime);
  return Math.max(0, worked - brk - idle);
};

const TotalOrders = ({ reports = [] }) => {
  const totalProdSeconds = reports.reduce(
    (acc, r) => acc + getProductiveSeconds(r.workedHours, r.breakTime, r.idleTime),
    0
  );

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <span>Productive Time</span>

        <h3 className="mb-0 fs-20">{secondsToHMS(totalProdSeconds)}</h3>

        <div className="py-3">
          <div className="wh-77 lh-97 text-center m-auto bg-primary-div bg-opacity-25 rounded-circle">
            <span className="material-symbols-outlined fs-32 text-primary-div">
              orders
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TotalOrders;
